<template>
  <div class="pageInner">
    <section class="resumo-forma" v-if="formaLocal">
      <div class="legenda">{{ formaLocal.nome }}</div>
      <h2>{{ formatMoney(formaLocal.valorTotalAtualizado || 0) }}</h2>
      <small v-if="hintForma">{{ hintForma }}</small>
    </section>
    <main class="overInner">
      <section class="lista">
        <article
          v-for="item in listaParcelasRender"
          :key="item.key"
          class="parcela-card"
        >
          <div class="date-input">
            <span
              v-if="isCartao(item)"
              class="month-pill"
            >
              {{ formatMonthBR(item.vencimento) }}
            </span>

            <span
              v-else-if="isPix(item)"
            >
              {{ formatDateBR(item.vencimento) }}
            </span>

            <input
              v-else
              type="date"
              :lang="'pt-BR'"
              :value="item.vencimento"
              :min="baseVencimento(item, item._index)"
              :max="addDias(baseVencimento(item, item._index), 5)"
              @input="onChangeVencimento(item, $event.target.value)"
            >
          </div>


          <!-- CONTEÚDO -->
          <div class="conteudo">
            <div class="top">
              <div class="chip">{{ pad2(item._seq) }}</div> 
            </div>
            <div class="valor">
              <h5 class="tipo">{{ item.tipoArrecadacao === 'entrada' ? 'Entrada' : 'Parcela' }}</h5>
              <h3> {{ formatMoney(item.valor) }}</h3>
            </div>
          </div>
        </article>
      </section>
    </main>

    <footer class="cta">
      <button-nav :disabled="enviando" @onClick="seguirParaTermo()">
        Seguir para termo
      </button-nav>
    </footer>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import NegociaService from '@/services/negocieja.service'
import { formatMoney } from '@/services/utils.service.js'
import ButtonNav from '@/components/financeiro/negocieja/app/navigation/ButtonNav.vue'
import moment from 'moment'
import 'moment/locale/pt-br'

export default {
  name: 'ParcelaResumo',

  components: { ButtonNav },

  props: {
    debitos: Object,
    idCampanha: { type: [String, Number], default: null },
    idPolitica: { type: [String, Number], default: null },
  },

  data () {
    return {
      payload: null,
      formaLocal: null,
      enviando: false,
      baseDates: {},
      cpfResponsavel: null
    }
  },
  computed: {
    hojeISO () {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },

    hintForma () {
      if (!this.formaLocal) return ''
      return 'Entrada de acordo com as condições selecionadas'
    },

    listaParcelasRender () {
      if (!this.payload) return []

      const ent = Array.isArray(this.payload?.entrada?.parcelas) ? this.payload.entrada.parcelas : []
      const parcs = Array.isArray(this.payload?.parcelas?.parcelas) ? this.payload.parcelas.parcelas : []

      let seq = 1

      const comMeta = (arr, bucket) => arr.map((p, idx) => ({
        ...p,
        _bucket: bucket,  
        _index: idx, 
        _seq: seq++,
        key: `${bucket}-${idx}-${p.vencimento || ''}-${p.valor || 0}`
      }))

      return [
        ...comMeta(ent, 'entrada'),
        ...comMeta(parcs, 'parcela')
      ]
    }

  },
  mounted () {
    this.carregarFormaLocal()
    this.gerarCronograma()
    
    if ( this.debitos ) {
      // console.log('parcelas mounted debitos:', this.debitos)
      this.cpfResponsavel = this.debitos.cpf_responsavel_financeiro
      console.log('cpfResponsavel:', this.cpfResponsavel)
    }
  },
  methods: {
    ...mapActions('negocieja', ['montarPayload']),

    baseVencimento (parcela, index) {
      const key = `${parcela.tipoArrecadacao}-${index}`
      if (!this.baseDates[key]) this.baseDates[key] = parcela.vencimento
      return this.baseDates[key]
    },

    addDias (dataISO, dias) {
      const d = new Date(dataISO)
      d.setDate(d.getDate() + dias)
      return d.toISOString().slice(0, 10)
    },

    isCartao (parcela) {
      if (parcela.tipoArrecadacao === 'parcela') return this.payload?.parcelas?.cartao === 1
      if (parcela.tipoArrecadacao === 'entrada') return this.payload?.entrada?.cartao === 1
      return false
    },

    isPix (parcela) {
      if (parcela.tipoArrecadacao === 'parcela') return this.payload?.parcelas?.pix === 1
      if (parcela.tipoArrecadacao === 'entrada') return this.payload?.entrada?.pix === 1
      return false
    },


    formatMonthBR (iso) {
      if (!iso) return ''
      const [y, m] = iso.split('-')
      return `${String(m).padStart(2, '0')}/${y}`
    },

    minPermitido (parcela) {
      return this.baseVencimento(parcela, parcela._index)
    },

    formatDateBR (iso) {
      if (!iso) return ''
      const [y, m, d] = iso.split('-')
      return `${String(d).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`
    },

    onChangeVencimento (item, novoISO) {
      const iso = this.toISODate(novoISO)

      const base = this.baseVencimento(item, item._index)
      const min = base
      const max = this.addDias(base, 5)

      let finalISO = iso
      if (iso < min) {
        finalISO = min
        window.toaster?.emit?.('open', {
          style: 'error',
          message: `Data mínima permitida: ${this.formatDateBR(min)}`,
          floater: true
        })
      } else if (iso > max) {
        finalISO = max
        window.toaster?.emit?.('open', {
          style: 'error',
          message: `Data máxima permitida: ${this.formatDateBR(max)}`,
          floater: true
        })
      }

      item.vencimento = finalISO

      if (item._bucket === 'entrada') {
        if (this.payload?.entrada?.parcelas?.[item._index]) {
          this.payload.entrada.parcelas[item._index].vencimento = finalISO
        }
      } else {
        if (this.payload?.parcelas?.parcelas?.[item._index]) {
          this.payload.parcelas.parcelas[item._index].vencimento = finalISO
        }
      }
    },

    ultimoDiaUtilDoMes (iso) {
      const m = moment(iso, 'YYYY-MM-DD').endOf('month')
      let d = m.clone()
      while (d.day() === 0 || d.day() === 6) d = d.subtract(1, 'day')
      return d.format('YYYY-MM-DD')
    },

    ajustarParaDiaUtil (iso) {
      let m = moment(iso, 'YYYY-MM-DD')
      while (m.day() === 0 || m.day() === 6) {
        m = m.add(1, 'day')
      }
      return m.format('YYYY-MM-DD')
    },

    ajustarPreferindoMesmoMes (iso) {
      const alvo = moment(iso, 'YYYY-MM-DD')
      const adiantado = this.ajustarParaDiaUtil(iso)
      if (moment(adiantado, 'YYYY-MM-DD').isSame(alvo, 'month')) return adiantado
      return this.ultimoDiaUtilDoMes(iso)
    },

    proximoDiaUtilEmNDias (n) {
      let m = moment().startOf('day')
      let count = 0
      while (count < n) {
        m = m.add(1, 'day')
        const dow = m.day()
        if (dow !== 0 && dow !== 6) count++
      }
      return m.format('YYYY-MM-DD')
    },

    maxISO (a, b) {
      return a > b ? a : b
    },

    aplicarRegrasDatasPayload () {
      if (!this.payload) return

      this.baseDates = {}

      const ent = Array.isArray(this.payload?.entrada?.parcelas)
        ? this.payload.entrada.parcelas
        : []

      const par = Array.isArray(this.payload?.parcelas?.parcelas)
        ? this.payload.parcelas.parcelas
        : []

      const basePrimeira = this.proximoDiaUtilEmNDias(5)
      const hoje = this.hojeISO

      const entradaPix = this.payload?.entrada?.pix === 1
      const parcelasPix = this.payload?.parcelas?.pix === 1

    if (entradaPix) {
      ent.forEach(p => {
        p.vencimento = hoje
      })
      } else {
        if (ent.length > 0) {
          const v0 = this.maxISO(ent[0].vencimento || basePrimeira, basePrimeira)
          ent[0].vencimento = this.ajustarPreferindoMesmoMes(v0)

          for (let i = 1; i < ent.length; i++) {
            const viBase = moment(ent[i - 1].vencimento, 'YYYY-MM-DD')
              .add(1, 'months')
              .format('YYYY-MM-DD')

            ent[i].vencimento = this.ajustarPreferindoMesmoMes(viBase)
          }
        }
      }

      let baseParcelas = basePrimeira
      if (!parcelasPix && ent.length > 0) {
        const entradaCartao = this.payload?.entrada?.cartao === 1
        const primeiraEntrada = ent[0]?.vencimento || basePrimeira
        const ultimaEntrada = ent[ent.length - 1]?.vencimento || basePrimeira
        const baseRef = entradaCartao ? primeiraEntrada : ultimaEntrada
        baseParcelas = moment(baseRef, 'YYYY-MM-DD')
          .add(1, 'months')
          .format('YYYY-MM-DD')
      }

      if (parcelasPix) {
        par.forEach(p => {
          p.vencimento = hoje
        })
      } else {
        if (par.length > 0) {
          const p0 = this.maxISO(par[0].vencimento || baseParcelas, baseParcelas)
          par[0].vencimento = this.ajustarPreferindoMesmoMes(p0)

          for (let i = 1; i < par.length; i++) {
            const viBase = moment(par[i - 1].vencimento, 'YYYY-MM-DD')
              .add(1, 'months')
              .format('YYYY-MM-DD')

            par[i].vencimento = this.ajustarPreferindoMesmoMes(viBase)
          }
        }
      }
    },

    renumerarSequencialPayload (payload) {
      let seq = 1

      if (Array.isArray(payload?.entrada?.parcelas)) {
        payload.entrada.parcelas.forEach(p => {
          p.parcela = seq++
        })
      }

      if (Array.isArray(payload?.parcelas?.parcelas)) {
        payload.parcelas.parcelas.forEach(p => {
          p.parcela = seq++
        })
      }

      return payload
    },

    paramsFromStorage () {
      try {
        return JSON.parse(localStorage.getItem('negocieja_parametros') || '{}')
      } catch { return {} }
    },

    cpfFromStorage () {
      try {
        const raw = localStorage.getItem('negociacaoDados')
        const obj = raw ? JSON.parse(raw) : {}
        const cpf = obj.cpf_responsavel_financeiro || obj.cpf || obj?.responsavelFinanceiro?.cpf || ''
        const digits = String(cpf).replace(/\D/g, '').slice(-11)
        return digits.length === 11 ? digits : ''
      } catch { return '' }
    },

    ensurePayloadForBackend (payload) {
      const paramsLS = this.paramsFromStorage()

      const cpfLS = this.cpfFromStorage()
      payload.cpf_responsavel_financeiro =
        this.cpfResponsavel ||
        this.debitos?.cpfResponsavel ||
        payload.cpf_responsavel_financeiro ||
        cpfLS || ''

      const totalOriginal =
        Number(this.debitos?.valorOriginal ??
              this.debitos?.valor?.totalOriginal ??
              payload?.valor?.totalOriginal ?? 0)

      const totalFinal =
        Number(this.formaLocal?.valorTotalAtualizado ??
              this.debitos?.valorFinal ??
              this.debitos?.valor?.totalFinal ??
              payload?.valor?.totalFinal ?? 0)

      payload.valor = {
        totalOriginal,
        totalFinal
      }

      payload.idNegocieJaCampanha = this.idCampanha ?? this.debitos?.idCampanha ?? null
      payload.idNegocieJaPolitica = this.idPolitica ?? this.debitos?.idPolitica ?? null

      const idForma = this.formaLocal?.idNegocieJaFormaPagamento ??
                      payload?.formaPagamento?.idFormaPagamento ?? null

      const p = {
        entradaTipo:  payload?.entrada?.pix ? 'pix'
        : payload?.entrada?.boleto ? 'boleto'
        : payload?.entrada?.cartao ? 'cartao'
        : (paramsLS.entradaTipo || ''),
        parcelaTipo:  payload?.parcelas?.pix ? 'pix'
        : payload?.parcelas?.boleto ? 'boleto'
        : payload?.parcelas?.cartao ? 'cartao'
        : (paramsLS.parcelaTipo || ''),
        entradaPercent: payload?.formaPagamento?.percentualEntrada ?? paramsLS.entradaPercent ?? null,
        qtdParcelas:    payload?.formaPagamento?.qtdParcelas ?? paramsLS.parcelas ?? null,
        qtdParcelasEntrada: payload?.formaPagamento?.qtdParcelasEntrada ?? paramsLS.qtdParcelasEntrada ?? null
      }

      payload.formaPagamento = {
        idFormaPagamento: idForma,
        percentualEntrada: p.entradaPercent,
        qtdParcelas: p.qtdParcelas,
        qtdParcelasEntrada: p.qtdParcelasEntrada
      }

      payload.entrada = {
        ...payload.entrada,
        pix:    p.entradaTipo === 'pix' ? 1 : null,
        boleto: p.entradaTipo === 'boleto' ? 1 : null,
        cartao: p.entradaTipo === 'cartao' ? 1 : null,
      }
      payload.parcelas = {
        ...payload.parcelas,
        pix:    p.parcelaTipo === 'pix' ? 1 : null,
        boleto: p.parcelaTipo === 'boleto' ? 1 : null,
        cartao: p.parcelaTipo === 'cartao' ? 1 : null,
      }

      if ('valores_corrigidos' in payload) delete payload.valores_corrigidos

      return payload
    },

    async gerarCronograma () {
      // const cpfLS = this.cpfFromStorage()

      this.payload = await this.montarPayload({
        cpf: this.debitos.cpfResponsavel,
        mencodigos: this.debitos?.mencodigos || [],
        idCampanha: this.idCampanha ?? this.debitos?.idCampanha ?? null,
        idPolitica: this.idPolitica ?? this.debitos?.idPolitica ?? null
      })

      this.carregarFormaLocal()

      this.aplicarRegrasDatasPayload()
      },

      carregarFormaLocal () {
        try {
          const raw = localStorage.getItem('negocieja_forma_escolhida')
          this.formaLocal = raw ? JSON.parse(raw) : null
        } catch (e) {
          this.formaLocal = null
        }
      },



      toISODate (val) {
        try {
          if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val
          const d = new Date(val)
          const y = d.getFullYear()
          const m = String(d.getMonth() + 1).padStart(2, '0')
          const day = String(d.getDate()).padStart(2, '0')
          return `${y}-${m}-${day}`
        } catch {
          return this.hojeISO
        }
      },

      pad2 (n) {
        const s = String(n || 0)
        return s.length === 1 ? `0${s}` : s
      },

      formatMoneyNumber (n) {
        try {
          return Number(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        } catch {
          return '0,00'
        }
      },
      formatMoney (v) {
        return formatMoney(v)
      },
      async seguirParaTermo () {
        try {
          this.enviando = true
          if (!this.payload) await this.gerarCronograma()

          const r3 = v => Math.round(Number(v || 0) * 1000) / 1000
          ;(this.payload?.entrada?.parcelas || []).forEach(p => p.valor = r3(p.valor))
          ;(this.payload?.parcelas?.parcelas || []).forEach(p => p.valor = r3(p.valor))

          this.renumerarSequencialPayload(this.payload)

          var payload = this.ensurePayloadForBackend({ ...this.payload })

          console.log("payload final......:", payload)
              payload.cpf_responsavel_financeiro = this.cpfResponsavel

          const res = await NegociaService.gerarProposta(payload)
          const data = res?.data || {}

          const retorno = {
            uuid: data.uuid,
            termo: data.pdf ? `data:application/pdf;base64,${data.pdf}` : null,
          }

          this.$emit('onNext', retorno)
            
          this.$router.push({ name: 'negociejaApp', params:{session: 'negociar', step:'termo', idProposta:data.uuid} })

        } catch (e) {
          console.error(e)
        } finally {
          this.enviando = false
        }
      },
  }
}
</script>

<style lang="scss" scoped>
.pageInner {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  height: 100%;
  overflow: hidden;
}

.overInner {
    height: 100%;
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-snap-type: y mandatory;

}


.resumo-forma {
  background: $azul-escuro;
  color: $azul;
  border-radius: $border-radius;
  padding: $border-radius;
  @extend %shadow-mid;

  .legenda {
    color: $branco;
    font-size: 16px;
    margin-bottom: 4px;
  }
  h2 {
    margin: 0;
    font-size: 22px;
    color: $azul;
    font-weight: 800;
  }
  small {
    display: block;
    color: $branco;
    margin-top: 6px;
    opacity: .85;
  }
}

.lista {
  display: flex;
  flex-direction: column;
  gap: 12px;
  
}

.parcela-card {
  display: grid;
  grid-template-columns: 120px  1fr;
  align-items: center;
  color: $branco;
  border-radius: 16px;
  scroll-snap-align: start;

}

.month-pill {
  color: $preto;
}

.data {
  display: flex;
  flex-direction: column;
  align-items: flex-start;


}
.date-input {
  display: flex;
  align-items: center;
  // gap: 8px;
  
  input {
    width: 110px;
  }

  span { 
    color: $preto;
  }

  input[type="date"] {
    background: transparent;
    border: none;
    outline: none;
    color: $preto;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    // &::-webkit-calendar-picker-indicator {
    //   opacity: 0;
    //   cursor: pointer;
    // }
  }

  .icon {
    color: $azul;
    font-size: 18px;
    cursor: pointer;
  }
}


.bullet {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: center;

  .icon {
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: $azul;
    border-radius: 50%;
    color: $branco;
  }
}

.conteudo {
    background-color: $azul-escuro;
    padding: $mg-small;
    border-radius: $border-radius;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

  .top {
    display: flex;
    align-items: center;
    gap: 8px;

    .chip {
      width: 32px;
      height: 32px;
      border-radius: 999px;
      background: $branco;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      color: $azul-escuro;
      font-size: 12px;  
    }
    .tipo {
      font-size: 14px;
      color: $branco;
      opacity: .95;
    }
  }

  .valor {
    display: flex;
    flex-direction: column;
    font-weight: 800;
    font-size: 16px;
    color: $branco;

    h5 {
        text-align: end;
    }
  }
}
</style>
